import { z } from 'zod';
import { MAX_IMAGE_SIZE_BYTES, MIN_IMAGE_SIZE_BYTES } from './constants.ts';

const MEGABYTE_FORMATTER = new Intl.NumberFormat('en', {
  style: 'unit',
  unit: 'megabyte',
  unitDisplay: 'long',
});
export const POST_SCHEMA = z.object({
  type: z.string().regex(/^image\//, {
    message: 'Invalid image type. Only image files are allowed.',
  }),
  data: z.instanceof(Uint8Array)
    .refine((data) => data.length >= MIN_IMAGE_SIZE_BYTES, {
      message: 'Image data cannot be empty',
    })
    .refine((data) => data.length <= MAX_IMAGE_SIZE_BYTES, {
      message: `Image data cannot exceed ${MEGABYTE_FORMATTER.format(
        MAX_IMAGE_SIZE_BYTES
      )}`,
    }),
});

export const GET_SCHEMA = z.object({
  filename: z.string(),
});